module.exports = __webpack_public_path__ + "static/img/saarland.99fe2ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/saarland.png
// module id = vvWm
// module chunks = 0